var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark2O(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "9px",
    viewBox: "0 0 13 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Selection",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.-Selection-3",
    transform: "translate(-222.000000, -488.000000)",
    fill: "#4FC3B8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tikkie-overview"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tikkie-cell-copy-2",
    transform: "translate(192.000000, 456.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-/-checkbox-/-not-selected",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2844258,8.30146328 C17.670217,7.90626255 18.303336,7.89863461 18.6985367,8.28442579 C19.0937374,8.67021697 19.1013654,9.303336 18.7155742,9.69853672 L11.8822409,16.6985367 C11.5074617,17.0824568 10.8964943,17.1022073 10.4977019,16.7432941 L6.33103527,12.9932941 C5.92052525,12.6238351 5.88724683,11.9915453 6.25670585,11.5810353 C6.62616487,11.1705252 7.25845471,11.1372468 7.66896473,11.5067059 L11.1218724,14.6143228 L17.2844258,8.30146328 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark2O);
export default __webpack_public_path__ + "static/media/checkmark2-o.97b9b96070ce800c029bc159f01a4dea.svg";
export { ForwardRef as ReactComponent };